var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.942,
    height: 15.942,
    viewBox: "0 0 15.942 15.942",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_002-exclamation",
    "data-name": "002-exclamation",
    transform: "translate(1 0.532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23322",
    "data-name": "Group 23322",
    transform: "translate(-1 -0.532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23321",
    "data-name": "Group 23321"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3914",
    "data-name": "Path 3914",
    d: "M12.608,1.335a7.971,7.971,0,1,0,0,11.273A7.971,7.971,0,0,0,12.608,1.335Zm-.939,10.333a6.642,6.642,0,1,1,0-9.394A6.642,6.642,0,0,1,11.668,11.668Z",
    transform: "translate(1 1)",
    fill: "#f46a6a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23323",
    "data-name": "Group 23323",
    transform: "translate(7.307 3.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3915",
    "data-name": "Path 3915",
    d: "M234.327,84.338c-.367,0-.664.214-.664.477v4.774c0,.264.3.477.664.477s.664-.214.664-.477V84.815C234.992,84.552,234.694,84.338,234.327,84.338Z",
    transform: "translate(-233.663 -84.338)",
    fill: "#f46a6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3916",
    "data-name": "Path 3916",
    d: "M234.327,383a.664.664,0,1,0,.664.664A.665.665,0,0,0,234.327,383Z",
    transform: "translate(-233.663 -375.947)",
    fill: "#f46a6a"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkError);
export default __webpack_public_path__ + "static/media/mark_error.886b9ce7f784e076c6173a5311b7c902.svg";
export { ForwardRef as ReactComponent };